import { AiFormFieldCaller, AiFormOptionsPage, AiFormOptionsQuery, AiFormRequests } from './ai-form.types';

export const AI_FORM_OPTIONS_PAGE_SIZE = 25;

export async function fetchAiFormOptions(path: string, signal?: AbortSignal, requests?: AiFormRequests): Promise<any> {
    if (signal?.aborted) throw new Error('Вызов инструмента отменён');
    if (requests) {
        if (!requests.has(path)) requests.set(path, fetchAiFormOptions(path, signal));
        return requests.get(path);
    }
    const response = await fetch(path, { credentials: 'same-origin', signal });
    if (/login/.test(new URL(response.url, window.location.origin).pathname)) {
        throw new Error('Не удалось получить варианты поля');
    }
    const data = await response.json();
    if (!response.ok) throw new Error(typeof data === 'string' ? data : data.errorMessage || 'Не удалось получить данные формы или справочника');
    if (data.result === false) throw new Error(data.errorMessage || 'Справочник недоступен');
    return data;
}

export function filterAiFormOptions(items: any[], query: AiFormOptionsQuery): AiFormOptionsPage {
    const search = (query.search ?? '').trim().toLocaleLowerCase();
    const filtered = items.filter(item => query.ids
        ? query.ids.includes(String(item.id))
        : !search || String(item.name).toLocaleLowerCase().includes(search));
    if (query.ids) return { items: filtered, hasMore: false };
    if (search) filtered.sort((left, right) => {
        const leftExact = String(left.name).trim().toLocaleLowerCase() === search;
        const rightExact = String(right.name).trim().toLocaleLowerCase() === search;
        return Number(rightExact) - Number(leftExact);
    });
    const offset = ((query.page ?? 1) - 1) * AI_FORM_OPTIONS_PAGE_SIZE;
    return { items: filtered.slice(offset, offset + AI_FORM_OPTIONS_PAGE_SIZE),
        hasMore: filtered.length > offset + AI_FORM_OPTIONS_PAGE_SIZE };
}

export function formOptions(
    optionsKey: string, path: string, responseKey?: string, normalize = (item: any) => item,
): AiFormFieldCaller {
    return async (query, { state, signal }) => {
        let items = state?.options?.[optionsKey];
        if (!items) {
            const data = await fetchAiFormOptions(path, signal);
            items = responseKey ? data[responseKey] : data;
        }
        if (!Array.isArray(items)) throw new Error(`Некорректный ответ справочника ${optionsKey}`);
        return filterAiFormOptions(items.map(normalize), query);
    };
}
